import { FunctionComponent, useEffect, useRef, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { BaseInfo, Guid } from "../../../api/baseApi";
import { getBaseChannelsForPriorityList, TimeSlotModel } from "../../../api/channelsApi";
import { createScheduledPriorityList, CreateScheduledPriorityListRequest, deleteScheduledList, disableScheduledList, enableScheduledList, enableScheduledListTimeSlot, getScheduledListTimeSlots, getScheduledPriorityLists, removeScheduledListTimeSlots, ScheduledPriorityList, ScheduledPriorityListStatus, updateScheduledPriorityList, UpdateScheduledPriorityListRequest } from "../../../api/priorityListApi";
import { createPathWithId, Routes } from "../../../constants/routes";
import { Button } from "../../components/Button";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import FormMultiSelect from "../../components/formRow/FormMultiSelect";
import { FormInput, FormInputNumber, FormRow, SelectOption } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import Schedule from "../../components/schedule/Schedule";
import { CenterModal, RightModal, SmallModal } from "../../components/sideModal/Modal";
import InnerLayout from "../innerLayout/InnerLayout";
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";

interface PriorityListProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}
 
const PriorityList: FunctionComponent<PriorityListProps> = (props : PriorityListProps) => {
    let [lists, setLists] = useState<ScheduledPriorityList[]>([]);
    let [channels, setChannels] = useState<BaseInfo[]>([]);
    let [channelOptions, setChannelOptions] = useState<SelectOption[]>([]);

    let [showModal, setShowModal] = useState<boolean>(false);
    let [isLoading, setIsloading] = useState<boolean>(false);

    let [listName, setListName] = useState<string>("");
    let [listNameError, setListNameError] = useState<boolean>(false);
    let [selectedChannels, setSelectedChannels] = useState<Guid[]>([]);
    let [listIdForEdit, setListIdForEdit] = useState<Guid>();

    let [showTimeSlotModal, setShowTimeSlotModal] = useState<boolean>(false);
    let [timeSlots, setTimeSlots] = useState<TimeSlotModel[]>([]);
    let [timeSlotChannelId, setTimeSlotChannelId] = useState<Guid>("");

    let [currentPagePriority, setCurrentPagePriority] = useState<number>(1);

    let [itemIdForDelete, setItemIdForDelete] = useState<Guid>('');
    let [itemNameForDelete, setItemNameForDelete] = useState<string>('');
    let [isShowSmallModalDeleteScheduledList, setIsShowSmallModalDeleteScheduledList] = useState(false);
    
    let [listItemsToDisplay, setListItemsToDisplay] = useState<ScheduledPriorityList[]>([])
    
    let itemsPerPage = 20;

    useEffect(() => {
        async function fetchData() {
            setIsloading(true);
            await Promise.all([getList(),getChannelsForList()]);
            setIsloading(false);
        };
        fetchData();
    }, []);

    useEffect(() => {
        let startIndex = (currentPagePriority - 1)*itemsPerPage;
        let finishIndex = startIndex + itemsPerPage;
        setListItemsToDisplay(lists.slice(startIndex, finishIndex));
    }, [lists, currentPagePriority]);

    let getList = async () => {
        setIsloading(true);
        var result = await getScheduledPriorityLists();
        if(result.type == 'succes'){
            setLists(result.data.items);
        }
        setIsloading(false);
    }

    let getChannelsForList = async () => {
        var channelsResult = await getBaseChannelsForPriorityList();
        if(channelsResult.type == "succes"){
            setChannels(channelsResult.data.items);
        }
    }


    const showCreateModal = () => {
        setChannelOptions(channels.map(mapChannelToOption));
        setShowModal(true);
    }

    const showEditModal = (list: ScheduledPriorityList) => {
        setChannelOptions([...channels, ...list.channels].map(mapChannelToOption));
        setListName(list.name);
        setSelectedChannels(list.channels.map(it => it.id));
        setListIdForEdit(list.id);
        setShowModal(true);
    }

    const closeModal = () => {
        setListIdForEdit(undefined);
        setListName('');
        setSelectedChannels([]);
        setShowModal(false);
    }

    const mapChannelToOption = (it: BaseInfo) : SelectOption => {
         return {value: it.id, name: it.name};
    }

    const onAddChannel = (id: Guid) => {
        setSelectedChannels([...selectedChannels, id]);
    } 

    const onRemoveChannel = (id: Guid) => {
        setSelectedChannels(selectedChannels.filter(it => it !== id));
    }

    const saveList = async () => {
        if(listName === "" || listName === undefined){
            setListNameError(true);
            return;
        }
        if(listIdForEdit === undefined){
            let request : CreateScheduledPriorityListRequest = { 
                channelIds: selectedChannels, 
                name: listName, 
            };
            await createScheduledPriorityList(request);
            setListName('');
            setSelectedChannels([]);
        }
        else{
            let request : UpdateScheduledPriorityListRequest =  { 
                channelIds: selectedChannels, 
                name: listName, 
                id: listIdForEdit,
            };
            await updateScheduledPriorityList(request);
            setListName('');
            setSelectedChannels([]);
        }
        await getList();
        await getChannelsForList();
        closeModal();
    }

    const openScheduleModal = async (id: Guid) => {
        setTimeSlotChannelId(id);
        let timeSlotsRequest = await getScheduledListTimeSlots(id);
        if(timeSlotsRequest.type == "succes"){
            setTimeSlots(timeSlotsRequest.data.items);
            setShowTimeSlotModal(true);
        }
    }    

    const onTimeSlotAdd = async (timeSlot: TimeSlotModel) => {
        var result = await enableScheduledListTimeSlot({...timeSlot}, timeSlotChannelId);
        if(result.type == "succes"){
            setTimeSlots([...timeSlots, {...timeSlot, id: result.data.id}]);    
        }
    }

    const onTimeSlotRemove = async (id: Guid) => {
        await removeScheduledListTimeSlots(timeSlotChannelId, id);
        setTimeSlots(timeSlots.filter(it => it.id !== id));     
    }

    const renderStatus = (status: ScheduledPriorityListStatus) => {
        switch(status){
            case ScheduledPriorityListStatus.Active : return <span className="status-active">Active</span>
            case ScheduledPriorityListStatus.Inactive : return <span className="status-paused">Inactive</span>
        }
    }

    const activate = async (id: Guid) => {
        await enableScheduledList(id);
        await getList();
    }

    const inactivate = async (id: Guid) => {
        await disableScheduledList(id);
        await getList();
    }

    const deleteScheduledPriorityList = async (id:Guid) => {
        setIsloading(true);
        setItemIdForDelete(id);
        await deleteScheduledList(id);
        await getList();
        await getChannelsForList();
        closeSmallModalScheduled();
        setIsloading(false);
    }

    const renderRow = (item: ScheduledPriorityList) => {
        return <tr key={item.id}>
        <td>{item.name}</td>
        <td>{item.channels.map(it => <p key={it.id}>{it.name}</p>)}</td>
        <td>{renderStatus(item.status)}</td>
        <td> 
            <IconButton tooltipText="Schedule" type="clock" onClick={() => openScheduleModal(item.id)} />
            { 
                item.status == ScheduledPriorityListStatus.Active 
                &&  <IconButton tooltipText="Stop" type="stop-play" onClick={() => inactivate(item.id)} />
            }
             { 
                item.status == ScheduledPriorityListStatus.Inactive 
                &&  <IconButton tooltipText="Play" type="play" onClick={() => activate(item.id)} />
            }
           
            <IconButton tooltipText="Edit" type="edit" onClick={() => { showEditModal(item)}}/>
            <IconButton tooltipText="Media" type="list-add" onClick={()=>{props.history.push(createPathWithId(Routes.PriorityList, item.id))}}/>
            <IconButton tooltipText="Delete" type="delete" onClick={()=>showSmallModalScheduled(item.id, item.name)} />
        </td>
        </tr>
    }

    const showSmallModalScheduled = (id:Guid, name: string) => {
        setItemIdForDelete(id);
        setItemNameForDelete(name);
        setIsShowSmallModalDeleteScheduledList(true);
    }

    const closeSmallModalScheduled = () => {
        setItemIdForDelete('');
        setItemNameForDelete('');
        setIsShowSmallModalDeleteScheduledList(false);
    }

    return (  
    <InnerLayout 
        isCollapsed={props.isCollapsed}
        logOut={props.logOut}
        toogleCollapse={props.toogleCollapse}
        activeTab="priorityList">
            <>
            <div className="d-flex justify-content-between align-items-center mb-20 pt-50">
                <h2>Streaming</h2>
                <Button color="green"  label="Add Streaming" onClick={showCreateModal} />
            </div>
            <table className="table">
                <thead>
                    <tr>
                        <td>Name</td>
                        <td>Networks </td>
                        <td>Status</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {listItemsToDisplay.map(it => renderRow(it))}
                </tbody>
            </table>
            
            <Pagination activePage={currentPagePriority} pagesCount={getPagesCount(lists.length, itemsPerPage)} changePaginationPage={setCurrentPagePriority} />

            <RightModal title={listIdForEdit === undefined ? "Add Streaming" : "Edit Streaming"} 
                    show={showModal}
                    onRequestClose={closeModal}
                    >
                        <FormRow>
                            <FormInput 
                                id="campaign-name"
                                title="Streaming Name"
                                isError={listNameError}
                                errorMessage="Please enter Streaming Name"
                                onChange={e => { setListName(e.target.value); setListNameError(false);}}
                                value={listName}
                            />
                        </FormRow>
                        <FormRow>
                            <FormMultiSelect
                                    id="players-list2"
                                    title="Networks"
                                    titleSelected="Selected Networks"
                                    isError={false}
                                    errorMessage="Please select Networks"
                                    onAdd={onAddChannel}
                                    onRemove={onRemoveChannel}
                                    options={channelOptions}
                                    selectedOptions={selectedChannels}
                                />
                        </FormRow>  
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={saveList}/>
                            <Button color="gray" label="Cancel" onClick={closeModal}/>
                        </div>
                        </RightModal>

                <CenterModal title="Scheduled Priority List" show={showTimeSlotModal} onRequestClose={() => setShowTimeSlotModal(false)} >
                    <Schedule 
                        timeSlots={timeSlots} 
                        onTimeSlotAdd={onTimeSlotAdd} 
                        onTimeSlotRemove={onTimeSlotRemove} 
                    />
                </CenterModal> 

                <SmallModal show={isShowSmallModalDeleteScheduledList} onRequestClose={closeSmallModalScheduled}> 
                    <p>That you want to delete list <b>{itemNameForDelete}</b>?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeSmallModalScheduled}/>
                        <Button color="green" label="Yes" onClick={()=>deleteScheduledPriorityList(itemIdForDelete)}/>
                    </div>
                </SmallModal>
                <GlobalSpinner isShow={isLoading} />
            </>
           
    </InnerLayout> );
}
 
export default withRouter(PriorityList);